import { render, staticRenderFns } from "./Scrubber.vue?vue&type=template&id=a8f53836"
import script from "./Scrubber.vue?vue&type=script&lang=js"
export * from "./Scrubber.vue?vue&type=script&lang=js"
import style0 from "./Scrubber.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports